// constant is typed as its value
export const ON_ACCOUNT_DATA: 'FBC/ON_ACCOUNT_DATA' = 'FBC/ON_ACCOUNT_DATA';
export const FETCH_DATA: 'FBC/FETCH_DATA' = 'FBC/FETCH_DATA';
export const ON_ACCOUNT_ERROR: 'FBC/ON_ACCOUNT_ERROR' = 'FBC/ON_ACCOUNT_ERROR';
export const SELECT_PAGE: 'FBC/SELECT_PAGE' = 'FBC/SELECT_PAGE';
export const TOGGLE_MODAL: 'FBC/TOGGLE_MODAL' = 'FBC/TOGGLE_MODAL';
export const ON_CONNECT: 'FBC/ON_CONNECT' = 'FBC/ON_CONNECT';
export const RESET: 'FBC/RESET' = 'FBC/RESET';
export const ON_LOGIN_STATUS_LOADED: 'FBC/ON_LOGIN_STATUS_LOADED' = 'FBC/ON_LOGIN_STATUS_LOADED';
